// Fills the %{name} placeholders of a translation the server passed in a data
// attribute. A placeholder without a value stays as it is.
export function interpolate(template, values = {}) {
  return (template || "").replace(/%\{(\w+)\}/g, (placeholder, name) => values[name] ?? placeholder)
}
